import React, { Component } from 'react';
import Item from './item';
import style from './index.css';

export interface IItemData {
    id: string;
    icon: string;
    tipMsg: string;
    disabled?: boolean;
    clickHandler?: () => {};
}
interface IProps {
    itemDatas: Array<IItemData>;
}

const blankItemData = {
    id: '',
    icon: '',
    tipMsg: '',
};
export default class Items extends Component<IProps> {
    public render() {
        const itemDataArr = this.processItemDatas();
        return <React.Fragment>
            {itemDataArr.map((arr, index) => <div key={index} className={style['add-items-container']}>
                {
                    arr.map((itemData, index) => <Item
                        key={itemData.id || index}
                        itemData={itemData}
                    />)
                }
            </div>)}
        </React.Fragment>;
    }

    private processItemDatas = () => {
        const { itemDatas } = this.props;
        const resultArr: Array<Array<IItemData>> = [];
        let tempArr: Array<IItemData> = [];
        itemDatas.forEach((item) => {
            tempArr.push(item);
            if (tempArr.length === 5) {
                resultArr.push(tempArr);
                tempArr = [];
            }
        });
        if (tempArr.length > 0) {
            while (tempArr.length < 5) {
                tempArr.push(blankItemData);
            }
            resultArr.push(tempArr);
        }
        return resultArr;
    };
}
